var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'check-cell-content btl': !_vm.isRtype }},[_c('creditcard-info',{attrs:{"is-rtype":_vm.isRtype}}),(!_vm.isRtype)?_c('div',{staticClass:"fieldset"},[_c('p',{staticClass:"divider notice fn-sm"},[_vm._v(" * 貼心提醒：當使用「信用卡紅利折抵」方式付款，若您單筆訂單中有多品項商品，後續辦理退貨僅能受理整筆訂單退貨。 ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }